import { QueryParams, TAG_TYPES } from 'types';
import { baseApi } from './index';
import { getQueryParams } from 'utils';
import { ProductImage } from 'models';

const urlEndpoint = `${process.env.REACT_APP_BASE_URL}/product-images`;
const tagType = TAG_TYPES.ProductImage;

const productImageApiService = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllProductImages: builder.query<
      {
        data: {
          rows: ProductImage[];
          count: number;
        };
        success: boolean;
      },
      { query: QueryParams }
    >({
      query: (params) => {
        const query = getQueryParams(params?.query);
        return {
          url: `${urlEndpoint}?${query}`,
          method: 'GET',
        };
      },
      providesTags: (result) => {
        return result
          ? [...(result?.data.rows || []).map(({ id }) => ({ type: tagType, id })), { type: tagType, id: 'LIST' }]
          : [{ type: tagType, id: 'LIST' }];
      },
    }),
  }),
});

export const { useGetAllProductImagesQuery } = productImageApiService;
